import React, { FunctionComponent, useState, useLayoutEffect } from 'react'

import Img from 'components/ui/Img'
import BreadcrumbProps from './resources/BreadcrumbProps.interface'
import SeparatorIcon from './chevron-right.svg'
import styles from './Breadcrumb.module.scss'

/**
 * @visibleName Breadcrumb
 * @version 1.0.0
 * @author [Rankmi](https://github.com/Rankmi)
 */

const Breadcrumb: FunctionComponent<BreadcrumbProps> = ({
  children,
  ariaLabel = 'Breadcrumbs',
  id,
  separator = <Img src={SeparatorIcon} alt="Separator Icon" />,
  className,
  contrast = false,
}) => {
  const [contrastState, setContrast] = useState<string | boolean>(contrast)
  const [classNames, setClassNames] = useState('')
  useLayoutEffect(() => {
    setContrast(contrastState ? styles[`contrast`] : false)
  }, [contrastState])
  useLayoutEffect(() => {
    setClassNames(
      [styles.breadcrumb, contrastState, className]
        .filter((item) => item)
        .join(' ')
    )
  }, [contrastState, className])
  return (
    <div
      id={id}
      role="navigation"
      aria-label={ariaLabel}
      className={classNames}
    >
      <ol>
        {React.Children.map(children, (child) => {
          return (
            <li>
              {child}
              <span className={styles.separator}>{separator}</span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export default Breadcrumb
